import styled from 'styled-components';

interface AiTextModalBodyWrapperProps {
    isMobile: boolean;
}

export const AiTextModalBodyWrapper = styled.div<AiTextModalBodyWrapperProps>`
    height: ${({ isMobile }) => (isMobile ? '591px' : '488px')};
    overflow: hidden auto;
`;
